function raiseEvent(name, details) {
    document.dispatchEvent(new CustomEvent(name, { detail: details }));
}
function handleEvent(name, handler) {
    document.addEventListener(name, handler);
}
const exceptionName = 'exceptionOccurred';
const deauthName = 'deauthorized';
const _events = {
    RaiseExceptionOccurred: (exception) => raiseEvent(exceptionName, exception),
    OnExceptionOccurred: (handler) => handleEvent(exceptionName, ev => handler(ev)),
    RaiseDeauthorized: (exception = null) => raiseEvent(deauthName, exception),
    OnDeauthorized: (handler) => handleEvent(deauthName, handler)
};
export default _events;
//# sourceMappingURL=events.js.map